import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type IcoLotteryData = Static<typeof IcoLotteryDataSchema>;
export const IcoLotteryDataSchema = Type.Object(
  {
    lotteryId: Type.String({ format: 'uuid' }),
    lotteryDrawId: Type.String({ format: 'uuid' }),
    lotteryDrawStartDate: Type.String({ format: 'date-time' }),
    lotteryDrawEndDate: Type.String({ format: 'date-time' }),
    lotterySignupType: Type.String(),
    lotteryRewardType: Type.String(),
    lotteryName: Type.String(),
  },
  { additionalProperties: false, $id: 'LotteryDataSchema' }
);

export type InteractionType = Static<typeof InteractionTypeSchema>;
export const InteractionTypeSchema = Type.Union([
  Type.Literal('lottery-reward-claimed'),
  Type.Literal('lottery-won'),
  Type.Literal('lottery-signed-up'),
]);

export type IcoPayload = Static<typeof IcoPayloadSchema>;
export const IcoPayloadSchema = Type.Object(
  {
    customerInteraction: Type.Array(
      Type.Object(
        {
          customerId: Type.String(),
          customerIdType: Type.Literal('CUSTOMER_ID_MASTER'),
          customerIdSource: Type.Literal('CM'),
          customerIdTrustCode: Type.Literal('MATCH.SYSTEM.IKEA'),
          locationCountryCode: Type.String(),
          locationType: Type.Literal('WEB'),
          locationCode: Type.String(),
          interactionId: Type.String(),
          interactionType: InteractionTypeSchema,
          interactionTypeVerNo: Type.Literal(1),
          interactionDatetime: Type.String({ format: 'date-time' }),
          interactionSystemId: Type.Literal('LOTTA'),
          customerInteractionDetail: Type.Array(
            Type.Object(
              {
                interactionDetailType: Type.Literal('LOTTERY'),
                data: IcoLotteryDataSchema,
              },
              { additionalProperties: false }
            )
          ),
        },
        { additionalProperties: false }
      )
    ),
  },
  { additionalProperties: false, $id: 'Payload' }
);

export type IcoResponseData = Static<typeof IcoResponseDataSchema>;
export const IcoResponseDataSchema = Type.Object(
  {
    messageStatus: Type.Union([Type.Literal('SUCCESS'), Type.String()]),
    messageCode: Type.String(),
    messageText: Type.String(),
    messageSeverity: Type.String(),
  },
  { additionalProperties: false, $id: 'ResponseDataSchema' }
);
